<template>
  <Teleport to="body">
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content tooltip-modal">
        <h3>Insert Tooltip ({{ tooltipType[iconType] }})</h3>
        <div class="modal-body">
          <label for="tooltipTitleInput">Title:</label>
          <input
            type="text"
            id="tooltipTitleInput"
            v-model="tooltipTitle"
            placeholder="Enter tooltip title"
          />
          <label for="tooltipBodyInput" style="margin-top: 10px">Body:</label>
          <textarea
            id="tooltipBodyInput"
            v-model="tooltipBody"
            placeholder="Enter tooltip body content"
            rows="4"
            style="
              width: 100%;
              padding: 8px 12px;
              border: 1px solid #ced4da;
              border-radius: 4px;
              box-sizing: border-box;
              resize: none;
            "
          ></textarea>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">Cancel</button>
          <button
            @click="insertTooltip"
            :disabled="!tooltipTitle || !tooltipBody"
          >
            Insert
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from "vue";

const props = defineProps({
  editor: {
    type: Object,
    required: true,
  },
  showModal: {
    type: Boolean,
    default: false,
  },
  iconType: {
    type: String,
    default: "hammer",
  },
});

const emit = defineEmits(["close"]);

const tooltipTitle = ref("");
const tooltipBody = ref("");
const tooltipType = {
  hammer: "Tech Troubleshooting",
  circle: "Differentiated Instruction",
  light: "Pedagogical/Design Justification",
};

// Reset form when modal opens
watch(
  () => props.showModal,
  (newVal) => {
    if (newVal) {
      tooltipTitle.value = "";
      tooltipBody.value = "";
    }
  }
);

const closeModal = () => {
  emit("close");
};

const insertTooltip = () => {
  if (props.editor && tooltipTitle.value && tooltipBody.value) {
    props.editor
      .chain()
      .focus()
      .setTooltipBlock({
        iconType: props.iconType,
        title: tooltipTitle.value,
        body: tooltipBody.value,
        isOpen: true, // Open initially in editor
      })
      .run();
    closeModal();
  }
};
</script>

<style scoped>
/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 500px;
}

.modal-content h3 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.25em;
  color: #343a40;
  text-align: center;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-body label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #495057;
}

.modal-body input[type="text"] {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  box-sizing: border-box;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer button {
  padding: 8px 15px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  cursor: pointer;
  font-size: 0.9em;
}

.modal-footer button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.modal-footer button.btn-cancel {
  background-color: #f8f9fa;
  color: #495057;
}
.modal-footer button.btn-cancel:hover {
  background-color: #e9ecef;
}

.modal-footer button:not(.btn-cancel) {
  background-color: var(--primary-blue);
  color: white;
  border-color: var(--primary-blue);
}
.modal-footer button:not(.btn-cancel):not(:disabled):hover {
  background-color: var(--primary-blue-dark);
  border-color: var(--primary-blue-dark);
}
</style>
